"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import API from "@ym-framework/api-utils";
import UiForm, { UiFormController } from "@/components/form/UiForm.vue";
import { UiFormAnnotations } from "@/components/form/annotations";
import UiSubmit from "@/components/form/UiSubmit.vue";
import QuestionSlot from "@/components/QuestionSlot.vue";
import i18n from "@/lang";
class RoleFormController extends UiFormController {
  constructor() {
    super(...arguments);
    this.roleName = "";
    this.roleDescription = "";
    this.shopRoleType = "ROLE_STAFF";
    this.shopScope = "selected";
    this.memberScope = "all";
    this.shopPowers = [];
    this.extensionPowers = [];
    this.teamPowers = [];
    this.logPowers = [];
    this.orgManagePowers = [];
    this.coinManagePowers = [];
    this.serviceManagePowers = [];
  }
}
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_roles.form.role_name_tip"),
      trigger: "blur"
    }
  ])
], RoleFormController.prototype, "roleName", 2);
__decorateClass([
  UiFormAnnotations.Rule([
    {
      required: true,
      message: i18n.t("add_roles.form.role_type_tip"),
      trigger: "blur"
    }
  ])
], RoleFormController.prototype, "shopRoleType", 2);
let AddRoles = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.mode = "create";
    this.id = "";
    this.addRolesLoading = false;
    this.roleFormController = new RoleFormController();
    this.shopPowersAll = false;
    this.extensionPowersAll = false;
    this.teamPowersAll = false;
    this.logPowersAll = false;
    this.orgManagePowersAll = false;
    this.coinManagePowersAll = false;
    this.serviceManagePowersAll = false;
    this.shopRoleTypes = [
      {
        "value": "ROLE_ADMIN",
        "label": this.$t("add_roles.form_power_label.shop_role_type_admin")
      },
      {
        "value": "ROLE_MANAGER",
        "label": this.$t("add_roles.form_power_label.shop_role_type_manager")
      },
      {
        "value": "ROLE_STAFF",
        "label": this.$t("add_roles.form_power_label.shop_role_type_employee")
      }
    ];
  }
  mounted() {
    return __async(this, null, function* () {
      if (this.$route.query.id) {
        this.mode = "edit";
        this.id = this.$route.query.id;
        this.getRoleInfo();
      }
    });
  }
  getRoleInfo() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v1/roles/${this.id}`);
        this.roleFormController.roleName = response.data.name;
        this.roleFormController.roleDescription = response.data.description;
        this.roleFormController.shopRoleType = response.data.code;
        let powers = response.data.powers;
        let shopPowers = [];
        let extensionPowers = [];
        let teamPowers = [];
        let logPowers = [];
        let coinManagePowers = [];
        let serviceManagePowers = [];
        for (let power of powers) {
          if (power.code === "VD_NAME_INVISIBLE" || power.code === "IMPORT_COOKIE" || power.code === "VD_LIST_MODE_INVISIBLE" || power.code === "SHOW_SHOP_AUTH_COUNT" || power.code === "SHOW_LAST_LOGIN" || power.code === "COOKIE_BACKUP" || power.code === "VIDEO_AUTH" || power.code === "DELETE_CACHE" || power.code === "SELECT_SHOP_PASSWORD" || power.code === "SHOP_EDIT" || power.code === "SHOP_CREATE") {
            shopPowers.push(power.code);
          }
          if (power.code === "PLUG_MANAGEMENT_PERSON" || power.code === "PLUG_MANAGEMENT") {
            extensionPowers.push(power.code);
          }
          if (power.code === "IN_PROCESS_MONITORING_APPROVAL" || power.code === "IN_PROCESS_MONITORING_SETTING" || power.code === "ACCESS_CONTROL_APPROVAL" || power.code === "ACCESS_CONTROL_SETTING" || power.code === "TEAM_LOGIN_APPROVAL" || power.code === "TEAM_LOGIN_SETTING" || power.code === "PASSWORD_EDIT" || power.code === "FORBIDDEN_AUTH_VD_MANAGER") {
            teamPowers.push(power.code);
          }
          if (power.code === "VD_NEW" || power.code === "INVOICE_MANAGEMENT" || power.code === "VD_UPGRADE" || power.code === "VIEW_ORDER_DETAIL" || power.code === "VD_RENEW" || power.code === "RECHARGE_COIN" || power.code === "COIN_DETAIL") {
            coinManagePowers.push(power.code);
          }
          if (power.code === "OPEN_API") {
            serviceManagePowers.push(power.code);
          }
          if (power.code === "VIEW_LOGIN_LOG" || power.code === "VIEW_MANAGEMENT_LOG" || power.code === "VIEW_VISIT_LOG" || power.code === "VIEW_RISK_LOG" || power.code === "VIEW_ACCOUNT_LOGIN_LOG" || power.code === "VIEW_TEAM_LOG" || power.code === "VIEW_TRAFFIC_LOG" || power.code === "EXPORT_VISIT_LOG" || power.code === "EXPORT_ACCOUNT_LOGIN_LOG") {
            logPowers.push(power.code);
          }
        }
        this.roleFormController.shopPowers = shopPowers;
        this.roleFormController.extensionPowers = extensionPowers;
        this.roleFormController.teamPowers = teamPowers;
        this.roleFormController.coinManagePowers = coinManagePowers;
        this.roleFormController.serviceManagePowers = serviceManagePowers;
        this.roleFormController.logPowers = logPowers;
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  goBack() {
    this.$router.push({ path: "/team", query: { "tab": "roleManage" } });
  }
  toScreen(position) {
    switch (position) {
      case position:
        document.querySelector(`#${position}`).scrollIntoView({
          behavior: "smooth"
        });
        break;
    }
  }
  shopPowersAllChange(value) {
    if (value) {
      this.roleFormController.shopPowers = [
        "SHOP_CREATE",
        "SHOP_EDIT",
        "SELECT_SHOP_PASSWORD",
        "DELETE_CACHE",
        "VIDEO_AUTH",
        "COOKIE_BACKUP",
        "SHOW_LAST_LOGIN",
        "SHOW_SHOP_AUTH_COUNT",
        "VD_LIST_MODE_INVISIBLE",
        "IMPORT_COOKIE",
        "VD_NAME_INVISIBLE"
      ];
    } else {
      this.roleFormController.shopPowers = [];
    }
  }
  shopPowersChange(data) {
    if (data.length === 4) {
      this.shopPowersAll = true;
    } else {
      this.shopPowersAll = false;
    }
  }
  extensionPowersAllChange(value) {
    if (value) {
      this.roleFormController.extensionPowers = [
        "PLUG_MANAGEMENT_PERSON",
        "PLUG_MANAGEMENT"
        // "PRIVATE_PLUGIN_UPLOAD",
        // "PRIVATE_PLUGIN_DELETE",
      ];
    } else {
      this.roleFormController.extensionPowers = [];
    }
  }
  extensionPowersChange(data) {
    if (data.length === 4) {
      this.extensionPowersAll = true;
    } else {
      this.extensionPowersAll = false;
    }
  }
  teamPowersAllChange(value) {
    if (value) {
      this.roleFormController.teamPowers = [
        "FORBIDDEN_AUTH_VD_MANAGER",
        "PASSWORD_EDIT",
        "TEAM_LOGIN_SETTING",
        "TEAM_LOGIN_APPROVAL",
        "ACCESS_CONTROL_SETTING",
        "ACCESS_CONTROL_APPROVAL",
        "IN_PROCESS_MONITORING_SETTING",
        "IN_PROCESS_MONITORING_APPROVAL"
      ];
    } else {
      this.roleFormController.teamPowers = [];
    }
  }
  teamPowersChange(data) {
    if (data.length === 3) {
      this.teamPowersAll = true;
    } else {
      this.teamPowersAll = false;
    }
  }
  logPowersAllChange(value) {
    if (value) {
      this.roleFormController.logPowers = [
        "VIEW_LOGIN_LOG",
        "VIEW_MANAGEMENT_LOG",
        "VIEW_VISIT_LOG",
        "VIEW_RISK_LOG",
        "VIEW_ACCOUNT_LOGIN_LOG",
        "VIEW_TEAM_LOG",
        "VIEW_TRAFFIC_LOG",
        "EXPORT_VISIT_LOG",
        "EXPORT_ACCOUNT_LOGIN_LOG"
      ];
    } else {
      this.roleFormController.logPowers = [];
    }
  }
  logPowersChange(data) {
    if (data.length === 9) {
      this.logPowersAll = true;
    } else {
      this.logPowersAll = false;
    }
  }
  orgManagePowersAllChange(value) {
    if (value) {
      this.roleFormController.orgManagePowers = [
        "ORG_CERTIFICATE",
        "LIVE_CERTIFICATE",
        "ORG_DELETE"
      ];
    } else {
      this.roleFormController.orgManagePowers = [];
    }
  }
  orgManagePowersChange(data) {
    if (data.length === 3) {
      this.orgManagePowersAll = true;
    } else {
      this.orgManagePowersAll = false;
    }
  }
  coinManagePowersAllChange(value) {
    if (value) {
      this.roleFormController.coinManagePowers = [
        "VD_NEW",
        "VD_RENEW",
        "RECHARGE_COIN",
        "COIN_DETAIL",
        "VIEW_ORDER_DETAIL",
        "VD_UPGRADE",
        "INVOICE_MANAGEMENT"
      ];
    } else {
      this.roleFormController.coinManagePowers = [];
    }
  }
  coinManagePowersChange(data) {
    if (data.length === 7) {
      this.coinManagePowersAll = true;
    } else {
      this.coinManagePowersAll = false;
    }
  }
  serviceManagePowersAllChange(value) {
    if (value) {
      this.roleFormController.serviceManagePowers = ["OPEN_API"];
    } else {
      this.roleFormController.serviceManagePowers = [];
    }
  }
  serviceManagePowersChange(data) {
    if (data.length === 1) {
      this.serviceManagePowersAll = true;
    } else {
      this.serviceManagePowersAll = false;
    }
  }
  submitForm() {
    return __async(this, null, function* () {
      try {
        yield this._roleForm._form.validate();
        if (this.mode === "create") {
          let params = {
            "name": this.roleFormController.roleName,
            "code": this.roleFormController.shopRoleType,
            "powerCodes": [
              ...this.roleFormController.shopPowers,
              ...this.roleFormController.extensionPowers,
              ...this.roleFormController.teamPowers,
              ...this.roleFormController.coinManagePowers,
              ...this.roleFormController.serviceManagePowers,
              ...this.roleFormController.logPowers
            ],
            "description": this.roleFormController.roleDescription
          };
          yield API.post(`api://base.auth/api/v1/roles`, params);
          this.$message.success(this.$t("add_roles.form.create_success"));
          this.goBack();
        } else {
          let params = {
            "name": this.roleFormController.roleName,
            "code": this.roleFormController.shopRoleType,
            "powerCodes": [
              ...this.roleFormController.shopPowers,
              ...this.roleFormController.extensionPowers,
              ...this.roleFormController.teamPowers,
              ...this.roleFormController.coinManagePowers,
              ...this.roleFormController.serviceManagePowers,
              ...this.roleFormController.logPowers
            ],
            "description": this.roleFormController.roleDescription
          };
          yield API.put(`api://base.auth/api/v1/roles/${this.id}`, params);
          this.$message.success(this.$t("add_roles.form.edit_success"));
          this.goBack();
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("roleForm")
], AddRoles.prototype, "_roleForm", 2);
AddRoles = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      QuestionSlot
    }
  })
], AddRoles);
export {
  AddRoles as default
};
